import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
export class PartialConnectError extends Error {
    constructor(failedAgreementNames){
        super('PartialConnectError'), _define_property(this, "failedAgreementNames", void 0), this.failedAgreementNames = failedAgreementNames;
        this.name = 'PartialConnectError';
    }
}
export const useConnectFundingSourceToAgreements = (param)=>{
    let { agreements, onSuccess } = param;
    const { api } = useStoreActions();
    const { mutateAsync, isLoading, isError } = useMutationState({
        mutationFn: async (param)=>{
            let { fundingSourceId, selectedAgreementIds } = param;
            if (selectedAgreementIds.length === 0) return;
            const results = await Promise.allSettled(selectedAgreementIds.map((agreementId)=>api.relationship.changePaymentMethod(agreementId, fundingSourceId)));
            const failedAgreementNames = selectedAgreementIds.filter((_, index)=>results[index].status === 'rejected').map((agreementId)=>{
                var _ref;
                var _agreements_find;
                return (_ref = (_agreements_find = agreements.find((agreement)=>agreement.id === agreementId)) === null || _agreements_find === void 0 ? void 0 : _agreements_find.name) !== null && _ref !== void 0 ? _ref : agreementId;
            });
            if (failedAgreementNames.length > 0) throw new PartialConnectError(failedAgreementNames);
        },
        onSuccess: (_data, param)=>{
            let { selectedAgreementIds } = param;
            return onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(selectedAgreementIds.length);
        }
    });
    return {
        connect: mutateAsync,
        isLoading,
        isError
    };
};
